import { useEffect, useState, useCallback } from 'react';

export default function useToggle(initialValue = false) {
  const [toggle, setToggle] = useState(initialValue);

  useEffect(() => {
    setToggle(initialValue);
  }, [initialValue]);

  const onToggle = useCallback((bool) => {
    setToggle(bool);
  }, []);

  const setOpen = useCallback(() => {
    setToggle(true);
  }, []);

  const onClose = useCallback(() => {
    setTimeout(() => {
      setToggle(false);
    }, 0);
  }, []);

  return { open: toggle, onToggle, setOpen, onClose };
}
